module.exports = __webpack_public_path__ + "img/frasle.44c55680.jpg";